// =====================================================================
// Wi-Fi Access / Guest Portal (R&D) — action types
// =====================================================================

// ---------- wifiaccesspoint (AP) ----------
export const WIFI_AP_LIST = "WIFI_AP_LIST";
export const WIFI_AP_LIST_SUCCESS = "WIFI_AP_LIST_SUCCESS";
export const WIFI_AP_LIST_FAIL = "WIFI_AP_LIST_FAIL";

export const WIFI_AP_DATA = "WIFI_AP_DATA";
export const WIFI_AP_DATA_SUCCESS = "WIFI_AP_DATA_SUCCESS";
export const WIFI_AP_DATA_FAIL = "WIFI_AP_DATA_FAIL";

export const WIFI_AP_CREATE = "WIFI_AP_CREATE";
export const WIFI_AP_CREATE_SUCCESS = "WIFI_AP_CREATE_SUCCESS";
export const WIFI_AP_CREATE_FAIL = "WIFI_AP_CREATE_FAIL";
export const WIFI_AP_CREATE_RESET = "WIFI_AP_CREATE_RESET";

export const WIFI_AP_UPDATE = "WIFI_AP_UPDATE";
export const WIFI_AP_UPDATE_SUCCESS = "WIFI_AP_UPDATE_SUCCESS";
export const WIFI_AP_UPDATE_FAIL = "WIFI_AP_UPDATE_FAIL";
export const WIFI_AP_UPDATE_RESET = "WIFI_AP_UPDATE_RESET";

export const WIFI_AP_DELETE = "WIFI_AP_DELETE";
export const WIFI_AP_DELETE_SUCCESS = "WIFI_AP_DELETE_SUCCESS";
export const WIFI_AP_DELETE_FAIL = "WIFI_AP_DELETE_FAIL";
export const WIFI_AP_DELETE_RESET = "WIFI_AP_DELETE_RESET";

// ---------- wifiportalguestprofile (PROFILE) ----------
export const WIFI_PROFILE_LIST = "WIFI_PROFILE_LIST";
export const WIFI_PROFILE_LIST_SUCCESS = "WIFI_PROFILE_LIST_SUCCESS";
export const WIFI_PROFILE_LIST_FAIL = "WIFI_PROFILE_LIST_FAIL";

export const WIFI_PROFILE_DATA = "WIFI_PROFILE_DATA";
export const WIFI_PROFILE_DATA_SUCCESS = "WIFI_PROFILE_DATA_SUCCESS";
export const WIFI_PROFILE_DATA_FAIL = "WIFI_PROFILE_DATA_FAIL";

export const WIFI_PROFILE_CREATE = "WIFI_PROFILE_CREATE";
export const WIFI_PROFILE_CREATE_SUCCESS = "WIFI_PROFILE_CREATE_SUCCESS";
export const WIFI_PROFILE_CREATE_FAIL = "WIFI_PROFILE_CREATE_FAIL";
export const WIFI_PROFILE_CREATE_RESET = "WIFI_PROFILE_CREATE_RESET";

export const WIFI_PROFILE_UPDATE = "WIFI_PROFILE_UPDATE";
export const WIFI_PROFILE_UPDATE_SUCCESS = "WIFI_PROFILE_UPDATE_SUCCESS";
export const WIFI_PROFILE_UPDATE_FAIL = "WIFI_PROFILE_UPDATE_FAIL";
export const WIFI_PROFILE_UPDATE_RESET = "WIFI_PROFILE_UPDATE_RESET";

export const WIFI_PROFILE_DELETE = "WIFI_PROFILE_DELETE";
export const WIFI_PROFILE_DELETE_SUCCESS = "WIFI_PROFILE_DELETE_SUCCESS";
export const WIFI_PROFILE_DELETE_FAIL = "WIFI_PROFILE_DELETE_FAIL";
export const WIFI_PROFILE_DELETE_RESET = "WIFI_PROFILE_DELETE_RESET";

// ---------- wifisitelocation (SITE) ----------
export const WIFI_SITE_LIST = "WIFI_SITE_LIST";
export const WIFI_SITE_LIST_SUCCESS = "WIFI_SITE_LIST_SUCCESS";
export const WIFI_SITE_LIST_FAIL = "WIFI_SITE_LIST_FAIL";

export const WIFI_SITE_DATA = "WIFI_SITE_DATA";
export const WIFI_SITE_DATA_SUCCESS = "WIFI_SITE_DATA_SUCCESS";
export const WIFI_SITE_DATA_FAIL = "WIFI_SITE_DATA_FAIL";

export const WIFI_SITE_CREATE = "WIFI_SITE_CREATE";
export const WIFI_SITE_CREATE_SUCCESS = "WIFI_SITE_CREATE_SUCCESS";
export const WIFI_SITE_CREATE_FAIL = "WIFI_SITE_CREATE_FAIL";
export const WIFI_SITE_CREATE_RESET = "WIFI_SITE_CREATE_RESET";

export const WIFI_SITE_UPDATE = "WIFI_SITE_UPDATE";
export const WIFI_SITE_UPDATE_SUCCESS = "WIFI_SITE_UPDATE_SUCCESS";
export const WIFI_SITE_UPDATE_FAIL = "WIFI_SITE_UPDATE_FAIL";
export const WIFI_SITE_UPDATE_RESET = "WIFI_SITE_UPDATE_RESET";

export const WIFI_SITE_DELETE = "WIFI_SITE_DELETE";
export const WIFI_SITE_DELETE_SUCCESS = "WIFI_SITE_DELETE_SUCCESS";
export const WIFI_SITE_DELETE_FAIL = "WIFI_SITE_DELETE_FAIL";
export const WIFI_SITE_DELETE_RESET = "WIFI_SITE_DELETE_RESET";

export const WIFI_SITE_UNIFI_TEST = "WIFI_SITE_UNIFI_TEST";
export const WIFI_SITE_UNIFI_TEST_SUCCESS = "WIFI_SITE_UNIFI_TEST_SUCCESS";
export const WIFI_SITE_UNIFI_TEST_FAIL = "WIFI_SITE_UNIFI_TEST_FAIL";
export const WIFI_SITE_UNIFI_TEST_RESET = "WIFI_SITE_UNIFI_TEST_RESET";

export const WIFI_SITE_UNIFI_SYNC = "WIFI_SITE_UNIFI_SYNC";
export const WIFI_SITE_UNIFI_SYNC_SUCCESS = "WIFI_SITE_UNIFI_SYNC_SUCCESS";
export const WIFI_SITE_UNIFI_SYNC_FAIL = "WIFI_SITE_UNIFI_SYNC_FAIL";
export const WIFI_SITE_UNIFI_SYNC_RESET = "WIFI_SITE_UNIFI_SYNC_RESET";

export const WIFI_SITE_COMO_TEST = "WIFI_SITE_COMO_TEST";
export const WIFI_SITE_COMO_TEST_SUCCESS = "WIFI_SITE_COMO_TEST_SUCCESS";
export const WIFI_SITE_COMO_TEST_FAIL = "WIFI_SITE_COMO_TEST_FAIL";
export const WIFI_SITE_COMO_TEST_RESET = "WIFI_SITE_COMO_TEST_RESET";

// ---------- wifiguestregistration (REG) ----------
export const WIFI_REG_LIST = "WIFI_REG_LIST";
export const WIFI_REG_LIST_SUCCESS = "WIFI_REG_LIST_SUCCESS";
export const WIFI_REG_LIST_FAIL = "WIFI_REG_LIST_FAIL";

export const WIFI_REG_DATA = "WIFI_REG_DATA";
export const WIFI_REG_DATA_SUCCESS = "WIFI_REG_DATA_SUCCESS";
export const WIFI_REG_DATA_FAIL = "WIFI_REG_DATA_FAIL";

export const WIFI_REG_SEARCH = "WIFI_REG_SEARCH";
export const WIFI_REG_SEARCH_SUCCESS = "WIFI_REG_SEARCH_SUCCESS";
export const WIFI_REG_SEARCH_FAIL = "WIFI_REG_SEARCH_FAIL";

// ---------- wifiportalerrorlog (ERRLOG) ----------
export const WIFI_ERRLOG_LIST = "WIFI_ERRLOG_LIST";
export const WIFI_ERRLOG_LIST_SUCCESS = "WIFI_ERRLOG_LIST_SUCCESS";
export const WIFI_ERRLOG_LIST_FAIL = "WIFI_ERRLOG_LIST_FAIL";

export const WIFI_ERRLOG_DATA = "WIFI_ERRLOG_DATA";
export const WIFI_ERRLOG_DATA_SUCCESS = "WIFI_ERRLOG_DATA_SUCCESS";
export const WIFI_ERRLOG_DATA_FAIL = "WIFI_ERRLOG_DATA_FAIL";

export const WIFI_ERRLOG_SEARCH = "WIFI_ERRLOG_SEARCH";
export const WIFI_ERRLOG_SEARCH_SUCCESS = "WIFI_ERRLOG_SEARCH_SUCCESS";
export const WIFI_ERRLOG_SEARCH_FAIL = "WIFI_ERRLOG_SEARCH_FAIL";

// ---------- wifisitelocationtowifiaccesspoint (LINK) ----------
export const WIFI_LINK_LIST = "WIFI_LINK_LIST";
export const WIFI_LINK_LIST_SUCCESS = "WIFI_LINK_LIST_SUCCESS";
export const WIFI_LINK_LIST_FAIL = "WIFI_LINK_LIST_FAIL";

export const WIFI_LINK_CREATE = "WIFI_LINK_CREATE";
export const WIFI_LINK_CREATE_SUCCESS = "WIFI_LINK_CREATE_SUCCESS";
export const WIFI_LINK_CREATE_FAIL = "WIFI_LINK_CREATE_FAIL";
export const WIFI_LINK_CREATE_RESET = "WIFI_LINK_CREATE_RESET";

export const WIFI_LINK_DELETE = "WIFI_LINK_DELETE";
export const WIFI_LINK_DELETE_SUCCESS = "WIFI_LINK_DELETE_SUCCESS";
export const WIFI_LINK_DELETE_FAIL = "WIFI_LINK_DELETE_FAIL";
export const WIFI_LINK_DELETE_RESET = "WIFI_LINK_DELETE_RESET";
